// extracted by mini-css-extract-plugin
export var container = "_eb-0";
export var infoIcon = "_eb-2";
export var internalLabel = "_eb-3";
export var titleRowCol = "_eb-1";